<template>
    <span v-if="variant">
        <router-link
            v-if="variant.type != 'info-vns'"
            class="convention-teaser-action"
            :to="link"
            @click.native="scrollTop"
        >
            <action :small="true" name="light"> Voir </action>
        </router-link>
        <a v-if="variant.type == 'info-vns'" :class="className" @click="openInfoVns">
            <action :small="true" name="light">Voir</action>
        </a>
    </span>
</template>

<script>
import { EventBus } from "src/bus/eventBus";
import scrollManager from "src/components/convention/managers/scrollManager.js";

export default {
    components: {},
    props: ["convention", "variant"],
    computed: {
        link() {
            return `/espace-client/conventions-collectives/${this.convention.conventionId}/${this.variant.variantNumber}`;
        },
    },
    methods: {
        scrollTop() {
            scrollManager.scrollTop();
        },
        openInfoVns() {
            EventBus.$emit("linked-content:show", this.variant.variantNumber);
        },
    },
};
</script>
